import { Box } from '@factorialco/deprecated-design-system'

import { Separator } from 'modules/integrations/components/SyncFooter/Separator'
import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

import { Issues } from './Issues'
import { IntegrationSettingsLink } from './IntegrationSettingsLink'
import { LastSync } from './LastSync'

const BASE_STYLES = {
  width: '100%',
  zIndex: '10',
  borderBottomLeftRadius: '14px',
  borderBottomRightRadius: '14px',
  alignItems: 'center',
  flexDirection: 'row',
  gap: '8px',
}

function SyncFooterContent() {
  return (
    <>
      <LastSync />
      <Separator />
      <Issues />
      <IntegrationSettingsLink />
    </>
  )
}

export const SyncFooter = () => {
  const { syncEnabled } = usePrivateIntegrationsSyncContext()

  if (!syncEnabled) return null

  return (
    <Box
      paddingTop="s8"
      paddingBottom="s12"
      paddingX="s24"
      background="grey100"
      style={BASE_STYLES}
    >
      <SyncFooterContent />
    </Box>
  )
}
